<template>
  <v-dialog
      v-model="notificationDialog"
      max-width="600px"
      @click:outside="sendClosePopup"
  >
    <v-card>
      <v-card-title class="d-flex justify-center notification-popup-title">
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row class="d-flex justify-center align-center">
            <a :href="notificationPopup.href" target="_blank" @click="setNotificationClicked">
              <img v-if="notificationPopup.image"
                   :src="notificationPopup.image" alt="notification_popup_image"
                   class="img-fluid text-center" style="max-width: 500px;"
              />
            </a>
            <p class="notification-popup-text mt-3">
              {{ notificationPopup.message }}
            </p>
            <v-col lg="9">
              <v-btn
                  color="second"
                  elevation="2"
                  x-large
                  class="w-100"
                  @click="sendClosePopup"
              >
                Kapat
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {getStorage, setStorage} from "@/views/Functions/Storage";

export default {
  name: "NotificationPopup",
  data: () => ({
    notificationDialog: false,
    notificationPopup: {}
  }),
  mounted() {
    setTimeout(() => {
      this.notificationPopup = this.getNotificationPopup()
      if (getStorage('notification_popup') === false && this.notificationPopup.id !== undefined) {
        this.notificationDialog = true;
      }
    }, 1000);
  },
  methods: {
    ...mapActions({send: 'asyncSender'}),
    ...mapGetters({getNotificationPopup: 'getNotificationPopup'}),
    ...mapMutations({setNotificationPopup: 'setNotificationPopup'}),

    sendClosePopup() {
      this.notificationDialog = false;
      this.sendNotification();
    },
    setNotificationClicked() {
      this.notificationDialog = false;
      this.sendNotification(true);
    },
    sendNotification(clicked = false){
      const route = clicked ? 'b/notification/c' : 'b/notification/r';
      const data = {id:this.notificationPopup.id};
      this.send({data, route});
      this.setNotificationPopup({});
      setStorage('notification_popup', true, 300);
    },
  }
}
</script>
<style scoped>
.notification-popup-title span {
  font-weight: bold;
  color: #68696b;
}

.notification-popup-text {
  text-align: center;
  font-size: 16px;
  opacity: 1;
  color: #68696b;
}

.notification-popup-text b {
  font-weight: bold;
  font-size: 18px;
  color: #000;
}
</style>